export const ORDER_SERVICE_STATUS_COLUMNS = [
  { key: 'AGUARDANDO', label: 'Aguardando', qtdKey: 'aguardando', accent: 'waiting' },
  { key: 'AGENDADO', label: 'Agendado', qtdKey: 'agendado', accent: 'scheduled' },
  { key: 'EM ANDAMENTO', label: 'Em andamento', qtdKey: 'emAndamento', accent: 'progress' },
  { key: 'FINALIZADO', label: 'Finalizado', qtdKey: 'finalizado', accent: 'done' },
  { key: 'CANCELADO', label: 'Cancelado', qtdKey: 'cancelado', accent: 'cancelled' },
] as const
